import { getErrorAction } from './errorMapper'
import { errorMessageAdd } from './toasts'
import uniqueId from 'lodash/uniqueId'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import { isChecklistItemIdNew } from '../util/checklistHelper'
import { arrayMove } from 'react-sortable-hoc'
import { createReducer } from './reducerUtils'
import moment from 'moment'
import { mergeMap, map, catchError, filter } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

export const GENERATED_TASK_CHECKLIST_ITEM_ID_PREFIX = 'unsaved-checklist-item-'

// Actions
export const TASK_CHECKLIST_ITEMS_LOAD = 'TASK_CHECKLIST_ITEMS_LOAD'
export const TASK_CHECKLIST_ITEMS_LOAD_SUCCESS = 'TASK_CHECKLIST_ITEMS_LOAD_SUCCESS'
export const TASK_CHECKLIST_ITEMS_LOAD_FAILURE = 'TASK_CHECKLIST_ITEMS_LOAD_FAILURE'

export const TASK_CHECKLIST_ITEMS_CREATE = 'TASK_CHECKLIST_ITEMS_CREATE'

export const TASK_CHECKLIST_ITEMS_ADD = 'TASK_CHECKLIST_ITEMS_ADD'
export const TASK_CHECKLIST_ITEMS_ADD_SUCCESS = 'TASK_CHECKLIST_ITEMS_ADD_SUCCESS'
export const TASK_CHECKLIST_ITEMS_ADD_FAILURE = 'TASK_CHECKLIST_ITEMS_ADD_FAILURE'

export const TASK_CHECKLIST_ITEM_MOVE = 'TASK_CHECKLIST_ITEM_MOVE'
export const TASK_CHECKLIST_ITEM_MOVE_SUCCESS = 'TASK_CHECKLIST_ITEM_MOVE_SUCCESS'
export const TASK_CHECKLIST_ITEM_MOVE_FAILURE = 'TASK_CHECKLIST_ITEM_MOVE_FAILURE'

export const TASK_CHECKLIST_ITEMS_UPDATE = 'TASK_CHECKLIST_ITEMS_UPDATE'
export const TASK_CHECKLIST_ITEMS_UPDATE_SUCCESS = 'TASK_CHECKLIST_ITEMS_UPDATE_SUCCESS'
export const TASK_CHECKLIST_ITEMS_UPDATE_FAILURE = 'TASK_CHECKLIST_ITEMS_UPDATE_FAILURE'

export const TASK_CHECKLIST_ITEMS_REMOVE = 'TASK_CHECKLIST_ITEMS_REMOVE'
export const TASK_CHECKLIST_ITEMS_DELETE = 'TASK_CHECKLIST_ITEMS_DELETE'
export const TASK_CHECKLIST_ITEMS_DELETE_SUCCESS = 'TASK_CHECKLIST_ITEMS_DELETE_SUCCESS'
export const TASK_CHECKLIST_ITEMS_DELETE_FAILURE = 'TASK_CHECKLIST_ITEMS_DELETE_FAILURE'

export const TASK_CHECKLIST_ITEMS_SAVE = 'TASK_CHECKLIST_ITEMS_SAVE'

// Action creators
export const taskChecklistItemsLoad = (taskId) => ({
  type: TASK_CHECKLIST_ITEMS_LOAD,
  payload: { taskId }
})

export const taskChecklistItemsLoadSuccess = (taskId, taskChecklistItems) => ({
  type: TASK_CHECKLIST_ITEMS_LOAD_SUCCESS,
  payload: { taskId, taskChecklistItems }
})

export const taskChecklistItemsLoadFailure = payload => ({
  type: TASK_CHECKLIST_ITEMS_LOAD_FAILURE,
  payload,
  error: true
})

export const defineChecklistItemActions = (checklistItem, task) => ({
  ...checklistItem,
  actions: {
    update: !!task.actions.update,
    delete: !!task.actions.update
  }
})

export const defineNewChecklistItemActions = (checklistItem) => ({
  ...checklistItem,
  actions: {
    update: true,
    delete: false
  }
})

export const setChecklistItemToReadOnly = (checklistItem) => ({
  ...checklistItem,
  actions: {
    update: false,
    delete: false
  }
})

export const taskChecklistItemsCreate = (taskId) => ({
  type: TASK_CHECKLIST_ITEMS_CREATE,
  payload: {
    taskId,
    tempChecklistItemId: uniqueId(GENERATED_TASK_CHECKLIST_ITEM_ID_PREFIX)
  }
})

export const taskChecklistItemsRemove = (taskId, checklistItemId) =>
  ({ type: TASK_CHECKLIST_ITEMS_REMOVE, payload: { taskId, checklistItemId } })

export const taskChecklistItemsDelete = (taskId, checklistItemId) =>
  ({ type: TASK_CHECKLIST_ITEMS_DELETE, payload: { taskId, checklistItemId } })

export const taskChecklistItemsDeleteSuccess = () =>
  ({ type: TASK_CHECKLIST_ITEMS_DELETE_SUCCESS })

export const taskChecklistItemsDeleteFailure = payload =>
  ({ type: TASK_CHECKLIST_ITEMS_DELETE_FAILURE, payload, error: true })

export const taskChecklistItemsSave = (taskId, checklistItemId, name, checked) => ({
  type: TASK_CHECKLIST_ITEMS_SAVE,
  payload: {
    taskId,
    checked,
    name,
    checklistItemId
  }
})

export const taskChecklistItemsAdd = (taskId, checklistItemId, checklistItemName) => ({
  type: TASK_CHECKLIST_ITEMS_ADD,
  payload: {
    taskId,
    checked: false,
    name: checklistItemName,
    tempChecklistItemId: checklistItemId
  }
})
export const taskChecklistItemsAddSuccess = (task, tempChecklistItemId, checklistItem) => ({
  type: TASK_CHECKLIST_ITEMS_ADD_SUCCESS,
  payload: { task, tempChecklistItemId, checklistItem }
})
export const taskChecklistItemsAddFailure = payload => ({
  type: TASK_CHECKLIST_ITEMS_ADD_FAILURE,
  payload,
  error: true
})

export const taskChecklistItemMove = (taskId, checklistItemId, nextChecklistItemId) => ({
  type: TASK_CHECKLIST_ITEM_MOVE,
  payload: { taskId, checklistItemId, nextChecklistItemId }
})
export const taskChecklistItemMoveSuccess = () =>
  ({ type: TASK_CHECKLIST_ITEM_MOVE_SUCCESS })
export const taskChecklistItemMoveFailure = payload => ({
  type: TASK_CHECKLIST_ITEM_MOVE_FAILURE,
  payload,
  error: true
})

export const taskChecklistItemsUpdate = (taskId, checklistItemId, name, checked) => ({
  type: TASK_CHECKLIST_ITEMS_UPDATE,
  payload: { taskId, checklistItemId, checked, name }
})
export const taskChecklistItemsUpdateSuccess = (task, checklistItemId, checklistItem) => ({
  type: TASK_CHECKLIST_ITEMS_UPDATE_SUCCESS,
  payload: { task, checklistItemId, checklistItem }
})
export const taskChecklistItemsUpdateFailure = payload => ({
  type: TASK_CHECKLIST_ITEMS_UPDATE_FAILURE,
  payload,
  error: true
})

const getChecklistItem = (checklistItems, id) => find(checklistItems, item => item.id === id)
const getChecklistItemIndex = (checklistItems, id) => findIndex(checklistItems, item => item.id === id)

// Epics
export const taskChecklistItemsLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_LOAD),
    mergeMap((action) =>
      vapiClient
        .getTaskChecklistItems(action.payload.taskId).pipe(
          map(ajaxResponse => ajaxResponse.response.map(item =>
            defineChecklistItemActions(item, state$.value.tasks[action.payload.taskId]))),
          map(checklistItems => taskChecklistItemsLoadSuccess(action.payload.taskId, checklistItems)),
          catchError(error => of(getErrorAction(error, taskChecklistItemsLoadFailure, action.payload)))
        )
    )
  )

export const taskChecklistItemsLoadFailureEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_LOAD_FAILURE),
    map(action => {
      const taskName = state$.value.tasks[action.payload.taskId].name
      return errorMessageAdd(
        localize(state$.value.resources, 'taskBoards.Msg_ChecklistLoadFailed')
          .replace('{taskName}', taskName)
      )
    })
  )

export const taskChecklistItemsSaveEpic = (action$, state$) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_SAVE),
    map(({ payload }) =>
      isChecklistItemIdNew(payload.checklistItemId)
        ? taskChecklistItemsAdd(payload.taskId, payload.checklistItemId, payload.name)
        : taskChecklistItemsUpdate(payload.taskId, payload.checklistItemId, payload.name, payload.checked)
    )
  )

export const taskChecklistItemsUpdateEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_UPDATE),
    mergeMap(({ payload }) => {
      const checklistItems = state$.value.taskChecklistItems[payload.taskId]
      const checklistItem = getChecklistItem(checklistItems, payload.checklistItemId)
      return vapiClient
        .updateTaskChecklistItem(payload.taskId, payload.checklistItemId, payload.name, payload.checked).pipe(
          map((ajaxResponse) => taskChecklistItemsUpdateSuccess(
            state$.value.tasks[payload.taskId],
            payload.checklistItemId,
            ajaxResponse.response)),
          catchError(error => of(getErrorAction(error, taskChecklistItemsUpdateFailure, { ...payload, checklistItem })))
        )
      }
    )
  )

export const taskChecklistItemsUpdateFailureEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_UPDATE_FAILURE),
    map(action => {
      const taskName = state$.value.tasks[action.payload.taskId].name
      return errorMessageAdd(
        localize(state$.value.resources, 'taskBoards.Msg_ChecklistItemSaveFailed')
          .replace('{taskName}', taskName)
      )
    })
  )

export const taskChecklistItemsAddEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_ADD),
    mergeMap((action) => vapiClient
      .addTaskChecklistItem(action.payload.taskId, action.payload.name).pipe(
        map((ajaxResponse) => taskChecklistItemsAddSuccess(
          state$.value.tasks[action.payload.taskId],
          action.payload.tempChecklistItemId,
          ajaxResponse.response)),
        catchError(error => of(getErrorAction(error, taskChecklistItemsAddFailure, action.payload)))
      )
    )
  )

export const taskChecklistItemsAddFailureEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_ADD_FAILURE),
    map(action => {
      const taskName = state$.value.tasks[action.payload.taskId].name
      return errorMessageAdd(
        localize(state$.value.resources, 'taskBoards.Msg_ChecklistItemSaveFailed')
          .replace('{taskName}', taskName)
      )
    })
  )

export const taskChecklistItemsDeleteEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_DELETE),
    filter(({ payload }) => !isChecklistItemIdNew(payload.checklistItemId)),
    mergeMap(({ payload }) => {
      const checklistItem = find(
        state$.value.taskChecklistItems[payload.taskId],
        item => item.id === payload.checklistItemId
      )
      return vapiClient
        .deleteTaskChecklistItem(payload.taskId, payload.checklistItemId).pipe(
          map((ajaxResponse) => taskChecklistItemsDeleteSuccess()),
          catchError(error =>
            of(getErrorAction(error, taskChecklistItemsDeleteFailure, { ...payload, checklistItem }))
          )
        )
    })
  )

export const taskChecklistItemsRemoveEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_DELETE),
    map(({ payload }) => taskChecklistItemsRemove(payload.taskId, payload.checklistItemId))
  )

export const taskChecklistItemsDeleteFailureEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEMS_DELETE_FAILURE),
    mergeMap(({ payload }) => {
      const taskName = state$.value.tasks[payload.taskId].name
      return [
        errorMessageAdd(
          localize(state$.value.resources, 'taskBoards.Msg_ChecklistItemDeleteFailed')
            .replace('{taskName}', taskName)
        ),
        taskChecklistItemsLoad(payload.taskId)
      ]
    })
  )

export const taskChecklistItemMoveEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEM_MOVE),
    mergeMap(({ payload }) => {
      return vapiClient
        .moveTaskChecklistItem(payload.taskId, payload.checklistItemId, payload.nextChecklistItemId).pipe(
          map((ajaxResponse) => taskChecklistItemMoveSuccess()),
          catchError(error =>
            of(getErrorAction(error, taskChecklistItemMoveFailure, payload))
          )
        )
    })
  )

export const taskChecklistItemMoveFailureEpic = (action$, state$, { localize }) =>
  action$.pipe(
    ofType(TASK_CHECKLIST_ITEM_MOVE_FAILURE),
    mergeMap(({ payload }) => {
      const taskName = state$.value.tasks[payload.taskId].name
      return [
        errorMessageAdd(
          localize(state$.value.resources, 'taskBoards.Msg_ChecklistItemMoveFailed')
            .replace('{taskName}', taskName)
        ),
        taskChecklistItemsLoad(payload.taskId)
      ]
    })
  )

// Reducer
const setChecklistItems = (state, taskId, checklistItems) => ({
  ...state,
  [taskId]: checklistItems
})

const removeChecklistItem = (state, taskId, checklistItemId) =>
  setChecklistItems(
    state,
    taskId,
    state[taskId].filter(checklistItem => checklistItem.id !== checklistItemId)
  )

const modifyChecklistItem = (state, taskId, checklistItemId, createNewValue) =>
  setChecklistItems(
    state,
    taskId,
    state[taskId].map(item => (item.id === checklistItemId) ? createNewValue(item) : item)
  )

const taskChecklistItemLoadSuccessReducer = (state, { taskId, taskChecklistItems }) =>
  setChecklistItems(state, taskId, taskChecklistItems)

const taskChecklistItemLoadFailureReducer = (state, { taskId }) => setChecklistItems(state, taskId, [])

const taskChecklistItemSaveReducer = (state, { taskId, checklistItemId, checked, name }) =>
  modifyChecklistItem(state, taskId, checklistItemId, item => ({ ...item, name, checked }))

const taskChecklistItemCreateReducer = (state, { taskId, tempChecklistItemId }) => {
  let currentChecklistItems = state[taskId] || []
  return setChecklistItems(
    state,
    taskId,
    [
      ...currentChecklistItems,
      defineNewChecklistItemActions({
        id: tempChecklistItemId,
        name: '',
        checked: false,
        createdOn: moment.utc().toISOString()
      })
    ]
  )
}

const taskChecklistItemAddReducer = (state, { taskId, tempChecklistItemId }) =>
  modifyChecklistItem(state, taskId, tempChecklistItemId, setChecklistItemToReadOnly)

const taskChecklistItemAddSuccessReducer = (state, { task, tempChecklistItemId, checklistItem }) =>
  modifyChecklistItem(state, task.id, tempChecklistItemId, () => defineChecklistItemActions(checklistItem, task))

const taskChecklistItemAddFailureReducer = (state, { taskId, tempChecklistItemId }) =>
  removeChecklistItem(state, taskId, tempChecklistItemId)

const taskChecklistItemRemoveReducer = (state, { taskId, checklistItemId }) =>
  removeChecklistItem(state, taskId, checklistItemId)

const taskChecklistItemUpdateFailureReducer = (state, { taskId, checklistItemId, checklistItem }) =>
  modifyChecklistItem(state, taskId, checklistItemId, () => checklistItem)

const taskChecklistItemDeleteFailureReducer = (state, { taskId }) => setChecklistItems(state, taskId, null)

const taskChecklistItemMoveReducer = (state, payload) => {
  const currentIndex = getChecklistItemIndex(state[payload.taskId], payload.checklistItemId)
  const nextIndex = payload.nextChecklistItemId
    ? getChecklistItemIndex(state[payload.taskId], payload.nextChecklistItemId)
    : state[payload.taskId].length
  return setChecklistItems(
    state,
    payload.taskId,
    arrayMove(state[payload.taskId], currentIndex, nextIndex < currentIndex ? nextIndex : nextIndex - 1)
  )
}

const taskChecklistItemMoveFailureReducer = (state, { taskId }) => setChecklistItems(state, taskId, null)

const taskChecklistItemsHandlerMapping = {
  [TASK_CHECKLIST_ITEMS_LOAD_SUCCESS]: taskChecklistItemLoadSuccessReducer,
  [TASK_CHECKLIST_ITEMS_LOAD_FAILURE]: taskChecklistItemLoadFailureReducer,
  [TASK_CHECKLIST_ITEMS_SAVE]: taskChecklistItemSaveReducer,
  [TASK_CHECKLIST_ITEMS_CREATE]: taskChecklistItemCreateReducer,
  [TASK_CHECKLIST_ITEMS_ADD]: taskChecklistItemAddReducer,
  [TASK_CHECKLIST_ITEMS_ADD_SUCCESS]: taskChecklistItemAddSuccessReducer,
  [TASK_CHECKLIST_ITEMS_ADD_FAILURE]: taskChecklistItemAddFailureReducer,
  [TASK_CHECKLIST_ITEMS_REMOVE]: taskChecklistItemRemoveReducer,
  [TASK_CHECKLIST_ITEMS_UPDATE_FAILURE]: taskChecklistItemUpdateFailureReducer,
  [TASK_CHECKLIST_ITEMS_DELETE_FAILURE]: taskChecklistItemDeleteFailureReducer,
  [TASK_CHECKLIST_ITEM_MOVE]: taskChecklistItemMoveReducer,
  [TASK_CHECKLIST_ITEM_MOVE_FAILURE]: taskChecklistItemMoveFailureReducer
}

const taskChecklistItemsInitialState = { }
export const taskChecklistItemsReducer = createReducer(taskChecklistItemsInitialState, taskChecklistItemsHandlerMapping)

export default taskChecklistItemsReducer



// WEBPACK FOOTER //
// ./src/store/taskChecklistItems.js